import { useEffect, useCallback, useMemo } from "react";
import { Select, SelectProps } from "antd";
import { getRoleList } from "../../api/user";
import { useRequest } from "../../hooks";

const cached: { current: null | RoleRecord[] } = {
    current: null
};
type Option = {
    value: string, label: string, name: string,
    disabled?: boolean,
}
export default function RoleSelect(props: Omit<SelectProps, 'options'> & {
    allowAdminSelection?: boolean;
    optionsFormatter?: (options?: Option[]) => Option[],
    onOptionChange?: (options: Option[]) => void
}) {
    const optionsFormatter = props.optionsFormatter || ((_options) => _options);
    const fetchData = useCallback(async () => {
        if (cached.current) return cached.current;
        const res = await getRoleList()
        const list = props.allowAdminSelection ? res.data : res.data.filter(i => i.name !== 'ADMIN')
        cached.current = list
        return list;
    }, [props.allowAdminSelection])
    const { data, loading } = useRequest(fetchData);
    const options = useMemo(() =>
        data?.map((i) => {
            return {
                value: String(i.roleId),
                label: i.description,
                ...i,
            }
        }), [data])
    useEffect(() => {
        props.onOptionChange?.(options || [])
    }, [options, props.onOptionChange])
    return <Select placeholder='请选择角色' {...props}
        loading={loading || props.loading}
        options={optionsFormatter(options)} />
}